import { Component } from 'react';
import { Time } from '../../../../../common/MomentTime';
import PortalModal from '../../../../../common/PortalModal';
import PortalTime from '../../../../../common/PortalTime';
import { Grid, Typography } from '@mui/material';
import { getShortTopic } from './utils';

class DeleteMeetingModal extends Component {
  //Θ(1) Returns the Delete Message
  getDeleteSingleMeetingDetails = (meeting) => {
    const meetingDate = Time.University(meeting.start_time).format('MMMM D');

    return (
      'Are you sure you want to delete ' + getShortTopic(meeting) + ' on ' + meetingDate + ' from'
    );
  };

  render() {
    return (
      <PortalModal
        maxWidth="md"
        onPrimaryClick={() => {
          this.props.deleteMeeting(this.props.meetingToDelete);
        }}
        onClose={this.props.toggleIsDeleteSingle}
        isOpen={this.props.isDeleteSingle}
        title="Delete Meeting"
        id="deleteSingleMeeting"
        primaryButtonTitle="Yes"
        isPrimaryButtonDisabled={this.props.isLoading}
        isCloseable={true}
        secondaryButtonTitle="No, Cancel"
        onSecondaryClick={this.props.toggleIsDeleteSingle}
      >
        <Typography component="p">
          {
            <Grid container direction={'row'}>
              {this.getDeleteSingleMeetingDetails(this.props.meetingToDelete)}
              &nbsp;
              <PortalTime
                time={Time.University(this.props.meetingToDelete.start_time).format('h:mm A')}
                title={
                  Time.University(this.props.meetingToDelete.start_time).format('h:mm A') +
                  ' Eastern Daylight Time. Events are always shown in the timezone for ODU.'
                }
              />
              &nbsp; to &nbsp;
              <PortalTime
                time={Time.University(this.props.meetingToDelete.start_time)
                  .add(this.props.meetingToDelete.duration, 'minutes')
                  .format('h:mm A')}
                title={
                  Time.University(this.props.meetingToDelete.start_time)
                    .add(this.props.meetingToDelete.duration, 'minutes')
                    .format('h:mm A') +
                  ' Eastern Daylight Time. Events are always shown in the timezone for ODU.'
                }
              />
              ?
            </Grid>
          }
        </Typography>
      </PortalModal>
    );
  }
}

export default DeleteMeetingModal;
